import { cn } from "@/lib/utils";

interface TableTagProps {
  text: string;
  className: string
}

export function TableTag({ text, className }: TableTagProps) {
  return (
    <div className={cn("px-1.5 h-4 bg-light-grey rounded-[4px] w-fit", className)}>
      <p className="paragraph-10 leading-[15px] text-black">{text}</p>
    </div>
  )
}
